import { render, staticRenderFns } from "./CoachScoutingReport.vue?vue&type=template&id=64de9690&scoped=true&"
import script from "./CoachScoutingReport.vue?vue&type=script&lang=ts&"
export * from "./CoachScoutingReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de9690",
  null
  
)

export default component.exports